import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import CircleLoader from 'app/components/CircleLoader/CircleLoader';
import FloatingRectangles from 'app/components/FloatingRectangles';

import style from './style.module.scss';

const StreamLoader: FC = () => {
  const { t } = useTranslation();

  return (
    <FloatingRectangles className={style.container}>
      <CircleLoader className={style.loader} size={35} />
      <div className={style.message}>{t('blocks_stream_loader')}</div>
    </FloatingRectangles>
  );
};

StreamLoader.displayName = 'StreamLoader';

export default StreamLoader;
